export default "__VITE_ASSET__BpuEopzf__"